module.exports = __webpack_public_path__ + "static/media/6.139135d1.jpeg";